export default __webpack_public_path__ + "74e97106f337bf11c2acde55cb3917b9.png";